"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[993,379],{

/***/ 5219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Button; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./src/themes/default/components/Loading/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &,\n  &:after {\n    border-radius: 50%;\n    width: 18px;\n    height: 18px;\n    background-color: transparent;\n  }\n  & {\n    font-size: 10px;\n    position: relative;\n    text-indent: -9999em;\n    border-top: 2px solid rgba(255, 255, 255, 0.2);\n    border-right: 2px solid rgba(255, 255, 255, 0.2);\n    border-bottom: 2px solid rgba(255, 255, 255, 0.2);\n    border-left: 2px solid #ffffff;\n    -webkit-transform: translateZ(0);\n    -ms-transform: translateZ(0);\n    transform: translateZ(0);\n    -webkit-animation: load8 1.1s infinite linear;\n    animation: load8 1.1s infinite linear;\n  }\n\n  @-webkit-keyframes load8 {\n    0% {\n      -webkit-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n    100% {\n      -webkit-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n  @keyframes load8 {\n    0% {\n      -webkit-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n    100% {\n      -webkit-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-51956618-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/themes/default/components/Loading/index.tsx


const Loading = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {});
};

// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 9 modules
var polished_esm = __webpack_require__(6637);
;// CONCATENATED MODULE: ./src/themes/default/components/Button/styles.ts

function styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          background: #fff;\n          color: ",
        ";\n\n          &:not(:disabled):hover {\n            filter: brightness(0.93);\n          }\n        "
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  color: ",
        ";\n                "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  background-color: ",
        ";\n                "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          &:not(:disabled):hover {\n            ",
        "\n          }\n        "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  cursor: pointer;\n  border: ",
        ";\n  border-radius: ",
        ";\n\n  font-weight: 500;\n\n  background-color: ",
        ";\n  color: ",
        ";\n\n  font-size: ",
        ";\n  padding: ",
        ";\n\n  line-height: ",
        ";\n\n  transition: color 0.3s, background-color 0.3s, filter ease-in 0.3s;\n  will-change: color, background-color;\n\n  width: ",
        ";\n\n  height: 36px;\n\n  ",
        "\n\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}


const StyledButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-cf07a0ae-0"
})(_templateObject4(), (p)=>"1px solid ".concat(p.transparent ? "transparent" : p.theme.colors[p.color]), (p)=>p.theme.borderRadius, (p)=>p.transparent ? "transparent" : p.theme.colors[p.color], (p)=>p.transparent ? p.theme.colors[p.color] : (0,polished_esm/* readableColor */.XV)((0,polished_esm/* darken */._j)(0.22, p.theme.colors[p.color]), p.theme.colors.textDark, p.theme.colors.textLight), (p)=>p.theme.font[p.font], (p)=>p.theme.button[p.size], (p)=>p.lineHeight && p.theme.spacing[p.lineHeight], (p)=>p.width ? "".concat(p.width * 100, "% !important") : "", (param)=>{
    let { theme , variant , color , transparent  } = param;
    return variant === "outlined" ? (0,styled_components_browser_esm/* css */.iv)(styles_templateObject(), theme.colors[color]) : (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), transparent ? (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), (0,polished_esm/* transparentize */.DZ)(0.15, theme.colors[color])) : (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), (0,polished_esm/* transparentize */.DZ)(0.15, theme.colors[color])));
});

;// CONCATENATED MODULE: ./src/themes/default/components/Button/index.tsx



const Button = (param)=>{
    let { children , size ="medium" , color ="primary" , font ="medium" , lineHeight , type , width , transparent , onClick , isLoading , disabled , variant ="default"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
        disabled: isLoading || disabled,
        transparent: transparent,
        size: size,
        font: font,
        color: color,
        lineHeight: lineHeight,
        type: type,
        width: width,
        onClick: onClick,
        variant: variant,
        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {}) : children
    });
};
/* harmony default export */ var components_Button = (Button);


/***/ }),

/***/ 9791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/hooks/useSiteSettings.tsx + 1 modules
var useSiteSettings = __webpack_require__(1371);
;// CONCATENATED MODULE: ./src/utils/formatCNPJ.ts
const formatCNPJ = (value)=>{
    if (!value) return value;
    const onlyNums = value.replace(/\D/g, "");
    return onlyNums.replace(/(\d{1,2})(\d{1,3})(\d{1,3})(\d{1,4})(\d{1,2})/g, "$1.$2.$3/$4-$5");
};

// EXTERNAL MODULE: ./src/utils/formatCPF.ts
var formatCPF = __webpack_require__(2970);
;// CONCATENATED MODULE: ./src/utils/formatDocument.ts


function formatDocument(document) {
    const newDocument = document.replace(/\D/g, "");
    if (newDocument.length < 14) {
        return (0,formatCPF/* formatCPF */.C)(newDocument);
    }
    return formatCNPJ(newDocument);
}

;// CONCATENATED MODULE: ./src/themes/lib/maskPhone.ts
const maskPhone = function() {
    let value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (!value) return value;
    const onlyNums = value.replace(/\D/g, "");
    if (onlyNums.length === 10) {
        return value.replace(/(\d{1,2})(\d{2,5})(\d{2,5})(.*)/, "($1) $2-$3");
    }
    return onlyNums.replace(/(\d{1,2})(\d{1})(\d{1,4})(\d{1,4})(.*)/, "($1) $2 $3-$4");
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./src/themes/default/components/Footer/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: ",
        ";\n  border-top: 1px solid ",
        ";\n  background-color: ",
        ";\n\n  flex-direction: column;\n  margin-top: auto;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  max-width: ",
        ";\n  padding: 0 ",
        ";\n\n  @media (max-width: 960px) {\n    padding: 0 ",
        ";\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n\n  width: 100%;\n\n  border-bottom: 1px solid ",
        ";\n  padding: ",
        " 0;\n  gap: ",
        ";\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  text-decoration: none;\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " 0;\n  padding-bottom: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  gap: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n\n  @media (max-width: 960px) {\n    flex-direction: column;\n  }\n\n  @media (max-width: 768px) {\n    padding-bottom: ",
        " !important;\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: ",
        ";\n\n  a {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    transition: opacity 0.4s;\n    will-change: opacity;\n\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  img {\n    height: 15px;\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}

const Wrapper = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
    componentId: "sc-d2fa6a7e-0"
})(_templateObject(), (p)=>p.theme.colors.textPrimary, (p)=>p.theme.colors.border, (p)=>p.theme.footer.background);
const Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d2fa6a7e-1"
})(_templateObject1(), (p)=>p.theme.maxWidth, (p)=>p.theme.spacing.xLarge, (p)=>p.theme.spacing.medium);
const TopFooter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d2fa6a7e-2"
})(_templateObject2(), (p)=>p.theme.colors.border, (p)=>p.theme.spacing.xLarge, (p)=>p.theme.spacing.xLarge);
const Text = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-d2fa6a7e-3"
})(_templateObject3(), (p)=>p.theme.font.small, (p)=>p.theme.spacing.medium, (p)=>p.theme.colors.textSecondary);
const StyledLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-d2fa6a7e-4"
})(_templateObject4(), (p)=>p.theme.font.small, (p)=>p.theme.spacing.medium, (p)=>p.theme.colors.textSecondary);
const BottomFooter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d2fa6a7e-5"
})(_templateObject5(), (p)=>p.theme.spacing.xLarge, (p)=>p.hasChat ? "calc(40px + ".concat(p.theme.spacing.xLarge, ")") : p.theme.spacing.xLarge, (p)=>p.theme.spacing.medium, (p)=>p.theme.font.small, (p)=>p.theme.colors.textSecondary, (param)=>{
    let { theme  } = param;
    return theme.spacing.xLarge;
});
const CreateBy = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d2fa6a7e-6"
})(_templateObject6(), (p)=>p.theme.spacing.small);
const Copyright = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d2fa6a7e-7"
})(_templateObject7());

;// CONCATENATED MODULE: ./src/themes/default/components/Footer/components/Section/styles.ts

function styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  width: max-content;\n  width: 180px;\n  min-width: 180px;\n  max-width: 180px;\n\n  text-align: center;\n  align-items: center;\n"
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  text-transform: uppercase;\n  margin-bottom: ",
        ";\n  white-space: nowrap;\n"
    ]);
    styles_templateObject1 = function() {
        return data;
    };
    return data;
}

const styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a5e96ea8-0"
})(styles_templateObject(), (p)=>p.theme.spacing.nano);
const Title = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-a5e96ea8-1"
})(styles_templateObject1(), (p)=>p.theme.font.xSmall, (p)=>p.theme.spacing.small);

;// CONCATENATED MODULE: ./src/themes/default/components/Footer/components/Section/index.tsx


const Section = (param)=>{
    let { title , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: title
            }),
            children
        ]
    });
};

;// CONCATENATED MODULE: ./src/themes/default/components/Footer/components/Contact/index.tsx




const Contact = (param)=>{
    let { contact  } = param;
    var ref, ref1, ref2, ref3, ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
        title: "Contato",
        children: [
            (contact === null || contact === void 0 ? void 0 : contact.phoneNumber) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                children: maskPhone(contact === null || contact === void 0 ? void 0 : contact.phoneNumber)
            }),
            (contact === null || contact === void 0 ? void 0 : contact.email) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                children: contact === null || contact === void 0 ? void 0 : contact.email
            }),
            (contact === null || contact === void 0 ? void 0 : contact.address) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text, {
                children: [
                    contact === null || contact === void 0 ? void 0 : (ref = contact.address) === null || ref === void 0 ? void 0 : ref.street,
                    ", ",
                    contact === null || contact === void 0 ? void 0 : (ref1 = contact.address) === null || ref1 === void 0 ? void 0 : ref1.number,
                    " -",
                    " ",
                    contact === null || contact === void 0 ? void 0 : (ref2 = contact.address) === null || ref2 === void 0 ? void 0 : ref2.neighborhood,
                    ", ",
                    contact === null || contact === void 0 ? void 0 : (ref3 = contact.address) === null || ref3 === void 0 ? void 0 : ref3.city,
                    " -",
                    " ",
                    contact === null || contact === void 0 ? void 0 : (ref4 = contact.address) === null || ref4 === void 0 ? void 0 : ref4.state
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-icons/bs/index.esm.js
var index_esm = __webpack_require__(3750);
// EXTERNAL MODULE: ./src/themes/default/components/Button/index.tsx + 3 modules
var Button = __webpack_require__(5219);
// EXTERNAL MODULE: ./src/themes/default/components/Form/Input/index.tsx + 1 modules
var Input = __webpack_require__(4800);
;// CONCATENATED MODULE: ./src/themes/default/components/Footer/components/Newsletter/styles.ts

function Newsletter_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: ",
        " 0;\n  border-bottom: 1px solid ",
        ";\n  text-align: center;\n  font-size: ",
        ";\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    Newsletter_styles_templateObject = function() {
        return data;
    };
    return data;
}
function Newsletter_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-transform: uppercase;\n  font-size: ",
        ";\n\n  @media (max-width: 768px) {\n  }\n"
    ]);
    Newsletter_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 50%;\n  line-height: ",
        ";\n  color: ",
        ";\n  font-weight: 300;\n\n  @media (max-width: 768px) {\n    max-width: 100%;\n  }\n"
    ]);
    styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: ",
        ";\n  flex: 1;\n  display: flex;\n  width: 100%;\n  max-width: 550px;\n\n  & input {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n    border-right: 0;\n  }\n\n  & button {\n    border-left: 0;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    aspect-ratio: 1 / 1;\n\n    svg {\n      stroke-width: 0.5px;\n    }\n  }\n"
    ]);
    styles_templateObject3 = function() {
        return data;
    };
    return data;
}

const Newsletter_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a45bd8fb-0"
})(Newsletter_styles_templateObject(), (p)=>p.theme.spacing.xxLarge, (p)=>p.theme.colors.border, (p)=>p.theme.font.small, (p)=>p.theme.spacing.medium);
const styles_Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-a45bd8fb-1"
})(Newsletter_styles_templateObject1(), (p)=>p.theme.font.xLarge);
const Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-a45bd8fb-2"
})(styles_templateObject2(), (p)=>p.theme.spacing.large, (p)=>p.theme.colors.textSecondary);
const WrapperForm = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    componentId: "sc-a45bd8fb-3"
})(styles_templateObject3(), (p)=>p.theme.borderRadius);

;// CONCATENATED MODULE: ./src/themes/default/components/Footer/components/Newsletter/index.tsx






const Newsletter = (param)=>{
    let { title , description , placeholder , onSend  } = param;
    const [email, setEmail] = (0,react.useState)("");
    function handleChangeEmail(e) {
        setEmail(e.target.value);
    }
    function handleSubmit(e) {
        e.preventDefault();
        onSend === null || onSend === void 0 ? void 0 : onSend(email);
        setEmail("");
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Newsletter_styles_Wrapper, {
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Title, {
                children: title
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                children: description
            }),
            onSend && /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperForm, {
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        name: "email",
                        placeholder: placeholder || "Digite seu endere\xe7o de e-mail",
                        value: email,
                        onChange: handleChangeEmail
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                        size: "xSmall",
                        type: "submit",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BsChevronRight */.fmn, {})
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/themes/default/components/Footer/components/Pages/index.tsx




const Pages = (param)=>{
    let { pages  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
        title: "P\xe1ginas",
        children: pages.map((page)=>{
            if (page.type === "url" && !!page.url) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                    href: page.url,
                    target: "_blank",
                    children: page.name
                }, page._id);
            }
            if (page.type === "html" && !!page.tag) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/paginas/".concat(page.tag),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                        as: "span",
                        children: page.name
                    })
                }, page._id);
            }
            return null;
        })
    });
};

;// CONCATENATED MODULE: ./src/themes/default/components/Footer/components/PaymentsWay/styles.ts

function PaymentsWay_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: ",
        ";\n  max-width: 75%;\n\n  > li {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    border-radius: ",
        ";\n    background: ",
        ";\n    height: 25px;\n\n    > img {\n      object-fit: contain;\n      object-position: center;\n      width: auto;\n      max-height: 100%;\n    }\n  }\n"
    ]);
    PaymentsWay_styles_templateObject = function() {
        return data;
    };
    return data;
}

const FlagsContainer = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-32adfe0a-0"
})(PaymentsWay_styles_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.spacing.small;
}, (param)=>{
    let { theme  } = param;
    return theme.borderRadius;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.background;
});

;// CONCATENATED MODULE: ./src/themes/default/components/Footer/components/PaymentsWay/index.tsx




const flags = [
    {
        name: "Visa",
        imageUrl: "/visa.png",
        containerPadding: 7,
        paymentMethods: [
            "credit_card"
        ]
    },
    {
        name: "Mastercard",
        imageUrl: "/mastercard.png",
        containerPadding: 4,
        paymentMethods: [
            "credit_card"
        ]
    },
    {
        name: "American Express",
        imageUrl: "/amex.png",
        containerPadding: 4,
        paymentMethods: [
            "credit_card"
        ]
    },
    {
        name: "Elo",
        imageUrl: "/elo.png",
        containerPadding: 6,
        paymentMethods: [
            "credit_card"
        ]
    },
    {
        name: "Hipercard",
        imageUrl: "/hipercard.png",
        containerPadding: 6,
        paymentMethods: [
            "credit_card"
        ]
    },
    {
        name: "Boleto",
        imageUrl: "/boleto.jpeg",
        containerPadding: 4,
        paymentMethods: [
            "boleto"
        ]
    },
    {
        name: "Pix",
        imageUrl: "/pix.png",
        containerPadding: 4,
        paymentMethods: [
            "pix"
        ]
    }
];
const PaymentsWay = ()=>{
    const { storeSettings  } = (0,useSiteSettings/* useSiteSettings */.h)();
    const configuratedFlags = flags.reduce((acc, flag)=>{
        const newAcc = acc || [];
        let isFlagConfigurated = false;
        flag.paymentMethods.forEach((item)=>{
            var ref, ref1;
            const existsInStorePaymentWays = storeSettings === null || storeSettings === void 0 ? void 0 : (ref = storeSettings.payment) === null || ref === void 0 ? void 0 : (ref1 = ref.availableMethods) === null || ref1 === void 0 ? void 0 : ref1.some((paymentMethod)=>paymentMethod.ref === item);
            if (existsInStorePaymentWays) {
                isFlagConfigurated = true;
            }
        });
        if (isFlagConfigurated) {
            newAcc.push(flag);
        }
        return newAcc;
    }, []);
    if (!configuratedFlags || configuratedFlags.length === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
        title: "Formas de Pagamento",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlagsContainer, {
            children: configuratedFlags.map((flag)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    style: {
                        padding: flag.containerPadding
                    },
                    "data-title": flag.name,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: flag.imageUrl,
                        alt: flag.name
                    })
                }, flag.name))
        })
    });
};

;// CONCATENATED MODULE: ./src/themes/default/components/Footer/components/SecuritySeals/styles.ts

function SecuritySeals_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  line-height: 1em;\n  gap: ",
        ";\n\n  > div {\n    > img {\n      object-fit: contain;\n      width: 100%;\n      max-width: 130px;\n    }\n  }\n\n  & > div {\n    display: flex;\n  }\n\n  @media (max-width: 768px) {\n    justify-content: center;\n  }\n"
    ]);
    SecuritySeals_styles_templateObject = function() {
        return data;
    };
    return data;
}

const WrapperSeals = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6c41ccf6-0"
})(SecuritySeals_styles_templateObject(), (p)=>p.theme.spacing.small);

;// CONCATENATED MODULE: ./src/themes/default/components/Footer/components/SecuritySeals/index.tsx



const SecuritySeals = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
        title: "Selo de seguran\xe7a",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperSeals, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "data-title": "Selo de seguran\xe7a",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/security-seal.png",
                    alt: "Selo de seguran\xe7a"
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(9583);
;// CONCATENATED MODULE: ./src/themes/default/components/Footer/components/SocialMedia/styles.ts

function SocialMedia_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  align-items: center;\n\n  color: ",
        ";\n  font-size: ",
        ";\n\n  padding: ",
        ";\n  border-radius: ",
        ";\n\n  transition: opacity 0.3s;\n\n  &:hover {\n    opacity: 0.75;\n  }\n\n  &.facebook {\n    color: #fff;\n    background-color: #4267b2;\n  }\n\n  &.twitter {\n    color: #fff;\n    background-color: #1da1f2;\n  }\n\n  &.youtube {\n    color: #fff;\n    background-color: #ff0000;\n  }\n\n  &.tiktok {\n    position: relative;\n    color: #fff;\n    background-color: #161823;\n\n    & svg {\n      position: relative;\n      z-index: 2;\n    }\n\n    & svg:first-child {\n      position: absolute;\n      z-index: 1;\n      top: 50%;\n      left: 50%;\n      transform: translate(-55%, -55%);\n\n      color: #23e8e2;\n    }\n\n    & svg:last-child {\n      position: absolute;\n      z-index: 1;\n      top: 50%;\n      left: 50%;\n      transform: translate(-45%, -45%);\n\n      color: #e21c4e;\n    }\n  }\n\n  &.instagram {\n    color: #fff;\n    background: rgb(64, 93, 230);\n    background: linear-gradient(\n      200deg,\n      rgba(64, 93, 230, 1) 5%,\n      rgba(91, 81, 216, 1) 10%,\n      rgba(131, 58, 180, 1) 20%,\n      rgba(193, 53, 132, 1) 40%,\n      rgba(225, 48, 108, 1) 50%,\n      rgba(253, 29, 29, 1) 60%,\n      rgba(245, 96, 64, 1) 70%,\n      rgba(247, 119, 55, 1) 80%,\n      rgba(252, 175, 69, 1) 90%,\n      rgba(255, 220, 128, 1) 100%\n    );\n  }\n"
    ]);
    SocialMedia_styles_templateObject = function() {
        return data;
    };
    return data;
}
function SocialMedia_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  line-height: 1em;\n  gap: ",
        ";\n\n  & > div {\n    display: flex;\n  }\n\n  @media (max-width: 768px) {\n    justify-content: center;\n  }\n"
    ]);
    SocialMedia_styles_templateObject1 = function() {
        return data;
    };
    return data;
}

const LinkSocial = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-e278b214-0"
})(SocialMedia_styles_templateObject(), (p)=>p.theme.colors.primary, (p)=>p.theme.font.xLarge, (p)=>p.theme.spacing.nano, (p)=>p.theme.spacing.quark);
const WrapperIcons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e278b214-1"
})(SocialMedia_styles_templateObject1(), (p)=>p.theme.spacing.small);

;// CONCATENATED MODULE: ./src/themes/default/components/Footer/components/SocialMedia/index.tsx




const SocialMedia = (param)=>{
    let { facebook , instagram , twitter , youtube , tiktok  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
        title: "Redes Sociais",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperIcons, {
            children: [
                facebook && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-title": "Facebook",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkSocial, {
                        href: facebook,
                        target: "_blank",
                        className: "facebook",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaFacebookF */.tBk, {})
                    })
                }),
                instagram && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-title": "Instagram",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkSocial, {
                        href: instagram,
                        target: "_blank",
                        className: "instagram",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaInstagram */.Zf_, {})
                    })
                }),
                twitter && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-title": "Twitter",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkSocial, {
                        href: twitter,
                        target: "_blank",
                        className: "twitter",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaTwitter */.fWC, {})
                    })
                }),
                youtube && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-title": "Youtube",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkSocial, {
                        href: youtube,
                        target: "_blank",
                        className: "youtube",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaYoutube */.V2E, {})
                    })
                }),
                tiktok && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-title": "TikTok",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkSocial, {
                        href: tiktok,
                        target: "_blank",
                        className: "tiktok",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaTiktok */.nTm, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaTiktok */.nTm, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaTiktok */.nTm, {})
                        ]
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/themes/default/components/Footer/index.tsx











const Footer = (param)=>{
    let { socialMedias , contact , createdByLogo , newsletter , pages  } = param;
    var ref;
    const { storeSettings , jivoChatSettings  } = (0,useSiteSettings/* useSiteSettings */.h)();
    const copyrightText = (0,react.useMemo)(()=>{
        const currentYear = new Date().getFullYear();
        return "Copyright \xa9 ".concat((storeSettings === null || storeSettings === void 0 ? void 0 : storeSettings.name) ? "".concat(storeSettings === null || storeSettings === void 0 ? void 0 : storeSettings.name, " - ") : "").concat((storeSettings === null || storeSettings === void 0 ? void 0 : storeSettings.document) ? "".concat(formatDocument(storeSettings.document), " - ") : "").concat(currentYear, ". Todos os direitos reservados.");
    }, [
        storeSettings === null || storeSettings === void 0 ? void 0 : storeSettings.name,
        storeSettings === null || storeSettings === void 0 ? void 0 : storeSettings.document
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
            children: [
                !!((ref = Object.keys(newsletter || {})) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Newsletter, {
                    ...newsletter
                }),
                (pages || contact || socialMedias || (storeSettings === null || storeSettings === void 0 ? void 0 : storeSettings.hasPaymentConfiguration)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopFooter, {
                    children: [
                        pages && /*#__PURE__*/ (0,jsx_runtime.jsx)(Pages, {
                            pages: pages
                        }),
                        contact && /*#__PURE__*/ (0,jsx_runtime.jsx)(Contact, {
                            contact: contact
                        }),
                        socialMedias && /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialMedia, {
                            ...socialMedias
                        }),
                        (storeSettings === null || storeSettings === void 0 ? void 0 : storeSettings.hasPaymentConfiguration) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsWay, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SecuritySeals, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomFooter, {
                    hasChat: !!(jivoChatSettings === null || jivoChatSettings === void 0 ? void 0 : jivoChatSettings.code),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Copyright, {
                            children: copyrightText
                        }),
                        createdByLogo && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CreateBy, {
                            children: [
                                "Criado com",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://pravendas.com.br",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: createdByLogo,
                                        alt: "Pra Vendas"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_Footer = (Footer);


/***/ }),

/***/ 4800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Form_Input; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var index_esm = __webpack_require__(6893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 9 modules
var polished_esm = __webpack_require__(6637);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./src/themes/default/components/Form/Input/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  height: 36px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute !important;\n  cursor: pointer;\n  font-size: ",
        ";\n  line-height: 1em;\n\n  top: 50%;\n  transform: translateY(-50%);\n\n  right: ",
        ";\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  padding: ",
        " 14px;\n  padding-right: ",
        ";\n  border-radius: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n  color: ",
        ";\n\n  transition: background-color 0.3s, border 0.3s;\n  will-change: background-color, border;\n\n  &:disabled {\n    background-color: ",
        ";\n  }\n\n  &:focus {\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}


const WrapperInput = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2b931ea9-0"
})(_templateObject());
const WrapperIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-2b931ea9-1"
})(_templateObject1(), (p)=>p.theme.font.small, (p)=>p.theme.spacing.medium);
const StyledInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-2b931ea9-2"
})(_templateObject2(), (p)=>p.theme.spacing.small, (p)=>p.hasIcon ? p.theme.spacing.xxLarge : p.theme.spacing.medium, (p)=>p.theme.borderRadius, (p)=>p.theme.font.small, (p)=>p.theme.spacing.medium, (p)=>p.theme.colors.border, (p)=>p.theme.input[p.color], (p)=>(0,polished_esm/* readableColor */.XV)((0,polished_esm/* darken */._j)(0.2, p.theme.input[p.color]), p.theme.colors.textDark, p.theme.colors.textLight), (p)=>p.theme.input.disabled, (p)=>p.theme.colors.primary);

;// CONCATENATED MODULE: ./src/themes/default/components/Form/Input/index.tsx




const Input = (param)=>{
    let { placeholder , disabled =false , color ="primary" , name , autoFocus =false , onChange , onBlur , value , onFocus , type , maxLength , onKeyPress  } = param;
    const [_type, setType] = (0,react.useState)(type);
    const hasIcon = (0,react.useMemo)(()=>{
        return type === "password";
    }, [
        type
    ]);
    const handleTogglePassword = ()=>{
        setType((prev)=>prev === "password" ? "text" : "password");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperInput, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInput, {
                hasIcon: hasIcon,
                autoFocus: autoFocus,
                id: name,
                name: name,
                color: color,
                placeholder: placeholder,
                disabled: disabled,
                onChange: onChange,
                onBlur: onBlur,
                onFocus: onFocus,
                onKeyPress: onKeyPress,
                value: value,
                type: _type,
                maxLength: maxLength
            }),
            hasIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperIcon, {
                "data-title": _type === "password" ? "Mostrar senha" : "Esconder senha",
                onClick: handleTogglePassword,
                children: _type === "password" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiLock */.UIZ, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiUnlock */.PdD, {})
            })
        ]
    });
};
/* harmony default export */ var Form_Input = (Input);


/***/ }),

/***/ 2970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ formatCPF; }
/* harmony export */ });
const formatCPF = (value)=>{
    if (!value) {
        return value;
    }
    const onlyNums = value.replace(/\D/g, "");
    return onlyNums.replace(/(\d{1,3})(\d{1,3})(\d{1,3})(\d{1,2})(.*)/, "$1.$2.$3-$4");
};


/***/ })

}]);